import React from "react";

import { Box, Typography } from "@mui/material";

import HTMLDisplay from "./HTMLDisplay";

const Variability_Plain = ({ variabilityData }) => {
  const dataToHtml = () => {
    let data = ``;

    console.log({ variabilityData });

    if (variabilityData && Array.isArray(variabilityData)) {
      for (const record of variabilityData) {
        data += "<div>";
        const fieldNames = Object.keys(record.data);

        for (const fieldName of fieldNames) {
          data += `<div style="font-size: 12px; font-weight: bold; text-decoration:underline; margin-top:8px">${fieldName}</div>`;
          data += `<div style="font-size: 10px">${record.data[fieldName]}</div>`;
        }

        data += "</div>";
      }
    }

    return data;
  };

  return (
    <Box sx={{ padding: "10px" }}>
      <HTMLDisplay
        html={dataToHtml()}
        noStyle
      />
    </Box>
  );
};

export default Variability_Plain;
